import { useContext } from "react";
import { ToastContext } from "@weezevent/nacre";

export const useToastContext = () => useContext(ToastContext);
